import Icon from '../components/Icon.vue'

Icon.register({
  'file-signature': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M218.2 424.1c7.3 14.5 21.7 23.4 37.8 23.8l128 0.1v40c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136c0 13.2 10.8 24 24 24h136v46.5l-128 127.1v82.1c-3.9-0.3-7.5-2.5-9.4-6.3-11.9-23.9-46.3-30.3-66-14.2l-13.9-41.6c-3.3-9.8-12.4-16.4-22.8-16.4s-19.5 6.6-22.8 16.4l-18.2 54.6c-1.5 4.6-5.8 7.7-10.6 7.7h-12.4c-8.8 0-16 7.2-16 16s7.2 16 16 16h12.4c18.6 0 35.1-11.9 41-29.5l10.6-31.9 16.8 50.5c4.5 13.5 23.1 14.9 29.5 2.1l7.7-15.3c2.8-5.6 7.9-6.2 10-6.2s7.2 0.6 10.2 6.5zM384 121.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9zM288 347l162.8-161.6 67.9 67.9-161.7 162.8h-69v-69zM568.5 167.3c10 9.9 10 26.1 0 36l-27.3 27.3-67.9-67.9 27.3-27.3c9.9-9.9 26.1-9.9 36 0z'
      }
    ]
  }
})
